export const LEVEL_PACKAGE = {
  CUSTOM: 98,
  ADMIN: 99,
  FREE: 0,
};
